import './Footer.css';
import { NavLink } from "react-router-dom";
import instagram from '../../assets/redesSociais/instagram.png';
import linkedin from '../../assets/redesSociais/linkedin.png';
import whatsapp from '../../assets/redesSociais/whatsapp.png';

function Footer() {
  return (
    <footer className="footer-elegant py-5 mt-5">
      <div className="container">
        <div className="row gy-4">
          <div className="col-12 col-md-4 pr-md-5">
            <h3 className="footer-brand">Villa Capetinga</h3>
            <p className="footer-text">Sua experiência de tranquilidade e conforto em meio à natureza de Santo Hilário.</p>
            <div className="d-flex gap-3 social-icons mt-4">
              <a href='https://www.instagram.com/villacapetinga/' target='_blank' rel='noreferrer'><img src={instagram} alt="Instagram" /></a>
              <a href='/' target='_blank' rel='noreferrer'><img src={linkedin} alt="LinkedIn" /></a>
              <a href='https://wa.me/qr/37QVHI4237N7F1' target='_blank' rel='noreferrer'><img src={whatsapp} alt="WhatsApp" /></a>
            </div>
          </div>
          
          <div className="col-6 col-md-2">
            <h4 className="footer-title">Navegação</h4>
            <ul className="list-unstyled footer-links">
              <li><NavLink to="/">Home</NavLink></li>
              <li><NavLink to="/sobre">Sobre</NavLink></li>
              <li><NavLink to="/contatos">Contatos</NavLink></li>
            </ul>
          </div>

          <div className="col-6 col-md-2">
            <h4 className="footer-title">Suporte</h4>
            <ul className="list-unstyled footer-links">
              <li><NavLink to="/">Regulamento</NavLink></li>
              <li><NavLink to="/">Acomodações</NavLink></li>
              <li><NavLink to="/contatos">Fale Conosco</NavLink></li>
            </ul>
          </div>

          <div className="col-12 col-md-4">
            <h4 className="footer-title">Contato</h4>
            <ul className="list-unstyled footer-contact">
              <li><i className="bi bi-telephone-fill"></i> +55 37 99904-1744</li>
              <li><i className="bi bi-envelope-fill"></i> villacapetinga@gmail.com</li>
              <li><i className="bi bi-geo-alt-fill"></i> R. José Tomé Filho, 26 - Santo Hilário, Pimenta - MG, 35585-000</li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom text-center mt-5 pt-4">
          <p className="mb-0">© {new Date().getFullYear()} Villa Capetinga. Todos os direitos reservados.</p>
        </div>
      </div>  
    </footer>
  );
}

export default Footer;